import type { NewsEntry } from "./news-types";

/** Auto-generated from git — do not edit. Run `node scripts/generate-news-entries.mjs`. */
export const GENERATED_NEWS_ENTRIES: NewsEntry[] = [
    {
        id: "2026-07-06-overload-x2-div2-score-picks-and-real-play-area-",
        date: "2026-07-06",
        title: "Overload: x2/div2 score picks and real play-area scaling.",
        description: "Overload: x2/div2 score picks and real play-area scaling.",
        category: "visual"
    },
    {
        id: "2026-07-06-add-subtle-ui-hover-toggle-sounds-and-ranking-po",
        date: "2026-07-06",
        title: "Add subtle UI hover/toggle sounds and ranking podium row styling.",
        description: "Add subtle UI hover/toggle sounds and ranking podium row styling.",
        category: "settings"
    },
    {
        id: "2026-07-06-improve-pc-cursor-responsiveness-remove-pointer-",
        date: "2026-07-06",
        title: "Improve PC cursor responsiveness: remove pointer-lock lag and unify s…",
        description: "Improve PC cursor responsiveness: remove pointer-lock lag and unify speedrun input.",
        category: "gameplay"
    },
    {
        id: "2026-07-06-fix-golf-so-cursor-always-blocks-the-ball-but-on",
        date: "2026-07-06",
        title: "Fix Golf so cursor always blocks the ball but only strikes when still.",
        description: "Fix Golf so cursor always blocks the ball but only strikes when still.",
        category: "bug-fix"
    },
    {
        id: "2026-07-06-rename-penalty-to-golf-and-tune-ball-speedrun-an",
        date: "2026-07-06",
        title: "Rename Penalty to Golf and tune ball, SpeedRun, and death freeze rules.",
        description: "Rename Penalty to Golf and tune ball, SpeedRun, and death freeze rules.",
        category: "bug-fix"
    },
    {
        id: "2026-06-22-enable-penalty-mode-view-counting-in-global-mode",
        date: "2026-06-22",
        title: "Enable Penalty mode view counting in global mode-plays handler.",
        description: "Enable Penalty mode view counting in global mode-plays handler.",
        category: "gameplay"
    },
    {
        id: "2026-06-20-fix-penalty-toggle-points-and-grouped-wall-colli",
        date: "2026-06-20",
        title: "Fix Penalty toggle points and grouped wall collision matching SpeedRu…",
        description: "Fix Penalty toggle points and grouped wall collision matching SpeedRun behavior.",
        category: "bug-fix"
    },
    {
        id: "2026-06-20-fix-penalty-ball-push-by-applying-hits-before-cu",
        date: "2026-06-20",
        title: "Fix Penalty ball push by applying hits before cursor collision clip.",
        description: "Fix Penalty ball push by applying hits before cursor collision clip.",
        category: "bug-fix"
    },
    {
        id: "2026-06-20-add-penalty-cursor-ball-collision-while-keeping-",
        date: "2026-06-20",
        title: "Add Penalty cursor-ball collision while keeping strike hit registrati…",
        description: "Add Penalty cursor-ball collision while keeping strike hit registration unchanged.",
        category: "visual"
    },
    {
        id: "2026-06-20-fix-penalty-ball-freezing-on-levels-with-lasers-",
        date: "2026-06-20",
        title: "Fix Penalty ball freezing on levels with lasers by correcting sweep c…",
        description: "Fix Penalty ball freezing on levels with lasers by correcting sweep collision.",
        category: "bug-fix"
    },
    {
        id: "2026-06-20-fix-speedrun-checkpoints-to-snapshot-pre-checkpo",
        date: "2026-06-20",
        title: "Fix SpeedRun checkpoints to snapshot pre-checkpoint progress and rest…",
        description: "Fix SpeedRun checkpoints to snapshot pre-checkpoint progress and restart level when none touched.",
        category: "bug-fix"
    },
    {
        id: "2026-06-19-add-reset-button-to-pause-menu-to-restart-the-cu",
        date: "2026-06-19",
        title: "Add Reset button to pause menu to restart the current game from scratch.",
        description: "Add Reset button to pause menu to restart the current game from scratch.",
        category: "visual"
    },
    {
        id: "2026-06-19-keep-speedrun-pre-checkpoint-progress-on-death-w",
        date: "2026-06-19",
        title: "Keep SpeedRun pre-checkpoint progress on death when level has checkpo…",
        description: "Keep SpeedRun pre-checkpoint progress on death when level has checkpoints.",
        category: "gameplay"
    },
    {
        id: "2026-06-19-fix-blank-speedrun-screen-when-levels-contain-po",
        date: "2026-06-19",
        title: "Fix blank SpeedRun screen when levels contain portals.",
        description: "Fix blank SpeedRun screen when levels contain portals.",
        category: "bug-fix"
    },
    {
        id: "2026-06-19-fix-speedrun-published-level-loading-picker-grid",
        date: "2026-06-19",
        title: "Fix SpeedRun published level loading, picker grid, and play start.",
        description: "Fix SpeedRun published level loading, picker grid, and play start.",
        category: "bug-fix"
    },
    {
        id: "2026-06-19-add-speedrun-portal-vortex-visuals-absorption-pa",
        date: "2026-06-19",
        title: "Add SpeedRun portal vortex visuals, absorption particles, and warp so…",
        description: "Add SpeedRun portal vortex visuals, absorption particles, and warp sound.",
        category: "gameplay"
    },
    {
        id: "2026-06-19-fix-speedrun-portal-exits-snapping-to-overlappin",
        date: "2026-06-19",
        title: "Fix SpeedRun portal exits snapping to overlapping solid walls.",
        description: "Fix SpeedRun portal exits snapping to overlapping solid walls.",
        category: "bug-fix"
    },
    {
        id: "2026-06-19-show-run-score-on-game-over-and-enlarge-the-defe",
        date: "2026-06-19",
        title: "Show run score on Game Over and enlarge the defeat screen layout.",
        description: "Show run score on Game Over and enlarge the defeat screen layout.",
        category: "gameplay"
    },
    {
        id: "2026-06-19-prevent-speedrun-solid-walls-from-being-tunneled",
        date: "2026-06-19",
        title: "Prevent speedrun solid walls from being tunneled at high cursor speed.",
        description: "Prevent speedrun solid walls from being tunneled at high cursor speed.",
        category: "gameplay"
    },
    {
        id: "2026-06-19-clear-local-account-data-on-logout-and-isolate-p",
        date: "2026-06-19",
        title: "Clear local account data on logout and isolate playtime per session.",
        description: "Clear local account data on logout and isolate playtime per session.",
        category: "visual"
    },
    {
        id: "2026-06-19-game-over-only-auto-retry-skips-it-quick-restart",
        date: "2026-06-19",
        title: "Game Over: only Auto Retry skips it; Quick restart no longer affects …",
        description: "Game Over: only Auto Retry skips it; Quick restart no longer affects death flow.",
        category: "bug-fix"
    },
    {
        id: "2026-06-19-portals-enter-from-either-side-with-mirrored-exi",
        date: "2026-06-19",
        title: "Portals: enter from either side with mirrored exit and bidirectional …",
        description: "Portals: enter from either side with mirrored exit and bidirectional plane cross.",
        category: "visual"
    },
    {
        id: "2026-06-19-fix-portal-ping-pong-block-passthrough-exit-latc",
        date: "2026-06-19",
        title: "Fix portal ping-pong: block passthrough, exit latch, no inside remap.",
        description: "Fix portal ping-pong: block passthrough, exit latch, no inside remap.",
        category: "bug-fix"
    },
    {
        id: "2026-06-18-portals-reliable-motion-sweep-and-trail-bridge-t",
        date: "2026-06-18",
        title: "Portals: reliable motion sweep and trail bridge through portal mouths.",
        description: "Portals: reliable motion sweep and trail bridge through portal mouths.",
        category: "visual"
    },
    {
        id: "2026-06-18-aim-30-bigger-balls-with-wave-pause-fade-fix-aut",
        date: "2026-06-18",
        title: "AIM: 30 bigger balls with wave pause/fade; fix Auto Retry and cursor …",
        description: "AIM: 30 bigger balls with wave pause/fade; fix Auto Retry and cursor feel.",
        category: "settings"
    },
    {
        id: "2026-06-17-tune-aim-20-balls-2s-timer-remove-golden-on-hit-",
        date: "2026-06-17",
        title: "Tune AIM: 20 balls, 2s timer, remove golden on hit, narrower bar.",
        description: "Tune AIM: 20 balls, 2s timer, remove golden on hit, narrower bar.",
        category: "visual"
    },
    {
        id: "2026-06-17-allow-aim-mobile-tap-while-another-finger-steers",
        date: "2026-06-17",
        title: "Allow AIM mobile tap while another finger steers the cursor.",
        description: "Allow AIM mobile tap while another finger steers the cursor.",
        category: "visual"
    },
    {
        id: "2026-06-17-aim-keep-balls-on-hit-reassign-golden-target-sma",
        date: "2026-06-17",
        title: "AIM: keep balls on hit, reassign golden target, smaller timer bar.",
        description: "AIM: keep balls on hit, reassign golden target, smaller timer bar.",
        category: "visual"
    },
    {
        id: "2026-06-17-aim-15-balls-tap-to-fire-on-mobile-remove-action",
        date: "2026-06-17",
        title: "AIM: 15 balls, tap-to-fire on mobile, remove action button.",
        description: "AIM: 15 balls, tap-to-fire on mobile, remove action button.",
        category: "visual"
    },
    {
        id: "2026-06-17-fix-squashed-balls-on-mobile-by-syncing-canvas-v",
        date: "2026-06-17",
        title: "Fix squashed balls on mobile by syncing canvas viewport aspect.",
        description: "Fix squashed balls on mobile by syncing canvas viewport aspect.",
        category: "bug-fix"
    },
    {
        id: "2026-06-17-fix-aim-golden-ball-clicks-cursor-aim-and-right-",
        date: "2026-06-17",
        title: "Fix AIM golden-ball clicks: cursor aim and right-click reshuffle.",
        description: "Fix AIM golden-ball clicks: cursor aim and right-click reshuffle.",
        category: "bug-fix"
    },
    {
        id: "2026-06-17-tune-aim-3s-timer-golden-only-ball-collisions-ne",
        date: "2026-06-17",
        title: "Tune AIM: 3s timer, golden-only ball collisions, News entry.",
        description: "Tune AIM: 3s timer, golden-only ball collisions, News entry.",
        category: "visual"
    },
    {
        id: "2026-06-17-add-aim-mode-click-golden-ball-under-1s-timer",
        date: "2026-06-17",
        title: "Add AIM mode: click golden ball under 1s timer.",
        description: "Add AIM mode: click golden ball under 1s timer.",
        category: "gameplay"
    },
    {
        id: "2026-06-17-fix-d-pad-customize-x-y-input-applying-wrong-vie",
        date: "2026-06-17",
        title: "Fix D-Pad customize X/Y input applying wrong viewport positions.",
        description: "Fix D-Pad customize X/Y input applying wrong viewport positions.",
        category: "bug-fix"
    },
    {
        id: "2026-06-17-fix-d-pad-customize-selection-and-drag-on-pc-by-",
        date: "2026-06-17",
        title: "Fix D-Pad customize selection and drag on PC by restoring drag thresh…",
        description: "Fix D-Pad customize selection and drag on PC by restoring drag threshold and improving pointer handling.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-restore-settings-card-row-sizing-and-enable-d-pa",
        date: "2026-06-16",
        title: "Restore Settings card row sizing and enable D-Pad customize on PC pre…",
        description: "Restore Settings card row sizing and enable D-Pad customize on PC preview.",
        category: "settings"
    },
    {
        id: "2026-06-16-revert-settings-to-card-grid-layout-keep-show-mo",
        date: "2026-06-16",
        title: "Revert Settings to card grid layout; keep Show Mobile Settings toggle.",
        description: "Revert Settings to card grid layout; keep Show Mobile Settings toggle.",
        category: "settings"
    },
    {
        id: "2026-06-16-tidy-settings-spacing-compact-sliders-and-pc-mob",
        date: "2026-06-16",
        title: "Tidy Settings spacing, compact sliders, and PC mobile-settings previe…",
        description: "Tidy Settings spacing, compact sliders, and PC mobile-settings preview toggle.",
        category: "settings"
    },
    {
        id: "2026-06-16-fix-settings-scroll-inside-a-bordered-scroll-box",
        date: "2026-06-16",
        title: "Fix Settings scroll inside a bordered scroll box.",
        description: "Fix Settings scroll inside a bordered scroll box.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-use-one-scrollable-settings-pane-with-all-sectio",
        date: "2026-06-16",
        title: "Use one scrollable Settings pane with all sections visible.",
        description: "Use one scrollable Settings pane with all sections visible.",
        category: "settings"
    },
    {
        id: "2026-06-16-redesign-settings-as-compact-os-style-vertical-l",
        date: "2026-06-16",
        title: "Redesign Settings as compact OS-style vertical lists.",
        description: "Redesign Settings as compact OS-style vertical lists.",
        category: "settings"
    },
    {
        id: "2026-06-16-fix-pc-cursor-spikes-and-extend-settings-action-",
        date: "2026-06-16",
        title: "Fix PC cursor spikes and extend Settings action toasts.",
        description: "Fix PC cursor spikes and extend Settings action toasts.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-let-settings-cards-size-independently-in-the-gri",
        date: "2026-06-16",
        title: "Let Settings cards size independently in the grid.",
        description: "Let Settings cards size independently in the grid.",
        category: "settings"
    },
    {
        id: "2026-06-16-replace-on-off-buttons-with-styled-toggle-switch",
        date: "2026-06-16",
        title: "Replace ON/OFF buttons with styled toggle switches.",
        description: "Replace ON/OFF buttons with styled toggle switches.",
        category: "settings"
    },
    {
        id: "2026-06-16-copy-toast-overlay-and-louder-mobile-master-audi",
        date: "2026-06-16",
        title: "Copy toast overlay and louder mobile master audio.",
        description: "Copy toast overlay and louder mobile master audio.",
        category: "visual"
    },
    {
        id: "2026-06-16-restore-settings-card-size-with-compact-slider-v",
        date: "2026-06-16",
        title: "Restore Settings card size with compact slider value inputs.",
        description: "Restore Settings card size with compact slider value inputs.",
        category: "settings"
    },
    {
        id: "2026-06-16-allow-simultaneous-d-pad-button-presses-for-diag",
        date: "2026-06-16",
        title: "Allow simultaneous D-Pad button presses for diagonal movement.",
        description: "Allow simultaneous D-Pad button presses for diagonal movement.",
        category: "visual"
    },
    {
        id: "2026-06-16-let-settings-slider-values-be-typed-directly",
        date: "2026-06-16",
        title: "Let Settings slider values be typed directly.",
        description: "Let Settings slider values be typed directly.",
        category: "settings"
    },
    {
        id: "2026-06-16-fix-settings-copy-crashing-before-clipboard-writ",
        date: "2026-06-16",
        title: "Fix Settings Copy crashing before clipboard write.",
        description: "Fix Settings Copy crashing before clipboard write.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-fix-settings-paste-rejecting-valid-copied-json-s",
        date: "2026-06-16",
        title: "Fix Settings Paste rejecting valid copied JSON snapshots.",
        description: "Fix Settings Paste rejecting valid copied JSON snapshots.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-export-full-settings-json-on-copy-and-loosen-pc-",
        date: "2026-06-16",
        title: "Export full Settings JSON on Copy and loosen PC cursor spike clamp.",
        description: "Export full Settings JSON on Copy and loosen PC cursor spike clamp.",
        category: "settings"
    },
    {
        id: "2026-06-16-match-sidebar-active-dot-to-the-button-gradient-",
        date: "2026-06-16",
        title: "Match sidebar active dot to the button gradient for visibility on dar…",
        description: "Match sidebar active dot to the button gradient for visibility on dark themes.",
        category: "visual"
    },
    {
        id: "2026-06-16-settings-copy-now-exports-every-option-in-a-full",
        date: "2026-06-16",
        title: "Settings Copy now exports every option in a full JSON snapshot.",
        description: "Settings Copy now exports every option in a full JSON snapshot.",
        category: "settings"
    },
    {
        id: "2026-06-16-fix-account-switch-leaking-playtime-stats-and-se",
        date: "2026-06-16",
        title: "Fix account switch leaking playtime, stats, and settings between users.",
        description: "Fix account switch leaking playtime, stats, and settings between users.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-pc-perfect-cursor-movement",
        date: "2026-06-16",
        title: "PC-perfect cursor movement",
        description: "The in-game cursor follows your mouse 1:1 with zero easing in every mode. Sandbox Smooth Cursor no longer adds lag.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-auto-retry-shows-game-over-when-on",
        date: "2026-06-16",
        title: "Auto Retry shows Game Over when ON",
        description: "Auto Retry ON now shows the Game Over screen after you die. OFF restarts immediately without Game Over.",
        category: "settings"
    },
    {
        id: "2026-06-16-custom-freeze-game-duration",
        date: "2026-06-16",
        title: "Custom Freeze Game duration",
        description: "With Lose animation OFF, set Freeze Game seconds (0.1–60) next to the toggle for how long the run stays frozen before Game Over.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-d-pad-customize-marquee-undo-redo-and-grid",
        date: "2026-06-16",
        title: "D-Pad Customize marquee, undo/redo, and grid",
        description: "Drag on empty space in Customize to box-select buttons and move them together. Toolbar adds Undo, Redo, and a Grid toggle that snaps buttons to visible cells sized to your buttons.",
        category: "settings"
    },
    {
        id: "2026-06-16-d-pad-customize-multi-select-and-opacity",
        date: "2026-06-16",
        title: "D-Pad Customize multi-select and opacity",
        description: "Customize adds an Opacity slider for all D-Pad buttons and multi-select drag for grouped moves. D-Pad button labels can no longer be text-selected.",
        category: "bug-fix"
    },
    {
        id: "2026-06-16-mobile-controls-settings-and-d-pad-grip",
        date: "2026-06-16",
        title: "Mobile controls settings and D-Pad grip",
        description: "The D-Pad grip handle shows only in Customize. Joystick moved under Mobile controls; Controls section removed. Pinch resize in Customize now scales all buttons.",
        category: "settings"
    },
    {
        id: "2026-06-16-d-pad-customize-sandbox-and-3s-mode-views",
        date: "2026-06-16",
        title: "D-Pad Customize sandbox and 3s mode views",
        description: "D-Pad Customize is a live sandbox with drag, pinch resize, layout cycling, and discard confirm on Return. Mode views count after 3 seconds.",
        category: "gameplay"
    },
    {
        id: "2026-06-16-d-pad-diagonal-buttons-and-pinch-resize",
        date: "2026-06-16",
        title: "D-Pad diagonal buttons and pinch resize",
        description: "Optional diagonal corner buttons on the mobile D-Pad. Pinch in Customize to resize all buttons. Mode popularity counts a view after 5 seconds.",
        category: "gameplay"
    },
    {
        id: "2026-06-16-mobile-d-pad-overhaul",
        date: "2026-06-16",
        title: "Mobile D-Pad overhaul",
        description: "Touch D-Pad uses fluid slide input, three layouts, and a unified D-Pad card in Settings with Diagonal Direction and Customize.",
        category: "settings"
    },
    {
        id: "2026-06-15-stabilize-pc-cursor-movement-across-modes-and-fi",
        date: "2026-06-15",
        title: "Stabilize PC cursor movement across modes and fix Modes Multiplayer s…",
        description: "Stabilize PC cursor movement across modes and fix Modes Multiplayer search visibility.",
        category: "visual"
    },
    {
        id: "2026-06-15-animate-cursorgame-title-with-a-smooth-ease-out-",
        date: "2026-06-15",
        title: "Animate CURSORGAME title with a smooth ease-out reveal when bootstrap…",
        description: "Animate CURSORGAME title with a smooth ease-out reveal when bootstrap loading ends.",
        category: "visual"
    },
    {
        id: "2026-06-15-fix-modes-search-input-losing-focus-after-one-ch",
        date: "2026-06-15",
        title: "Fix Modes search input losing focus after one character.",
        description: "Fix Modes search input losing focus after one character.",
        category: "bug-fix"
    },
    {
        id: "2026-06-14-highlight-counter-target-ball-with-gold-fill-and",
        date: "2026-06-14",
        title: "Highlight Counter target ball with gold fill and glowing number.",
        description: "Highlight Counter target ball with gold fill and glowing number.",
        category: "visual"
    },
    {
        id: "2026-06-14-add-counter-mode-with-ordered-numbered-balls-and",
        date: "2026-06-14",
        title: "Add Counter mode with ordered numbered balls and 5s step timer.",
        description: "Add Counter mode with ordered numbered balls and 5s step timer.",
        category: "gameplay"
    },
    {
        id: "2026-06-14-add-speedrun-point-types-so-toggle-lasers-hide-p",
        date: "2026-06-14",
        title: "Add speedrun point types so toggle lasers hide per shape and group.",
        description: "Add speedrun point types so toggle lasers hide per shape and group.",
        category: "settings"
    },
    {
        id: "2026-06-14-save-personal-bests-immediately-on-death-so-reco",
        date: "2026-06-14",
        title: "Save personal bests immediately on death so records persist during th…",
        description: "Save personal bests immediately on death so records persist during the lose animation.",
        category: "visual"
    },
    {
        id: "2026-06-14-add-frosted-glass-hud-style-to-return-and-pause-",
        date: "2026-06-14",
        title: "Add frosted glass HUD style to Return and Pause buttons during play.",
        description: "Add frosted glass HUD style to Return and Pause buttons during play.",
        category: "visual"
    },
    {
        id: "2026-06-14-add-zone-patrol-and-activation-for-hunter-red-ba",
        date: "2026-06-14",
        title: "Add zone patrol and activation for Hunter red balls.",
        description: "Add zone patrol and activation for Hunter red balls.",
        category: "visual"
    },
    {
        id: "2026-06-14-rebalance-hunter-spawns-and-add-pack-hunting-ai-",
        date: "2026-06-14",
        title: "Rebalance Hunter spawns and add pack-hunting AI for red balls.",
        description: "Rebalance Hunter spawns and add pack-hunting AI for red balls.",
        category: "visual"
    },
    {
        id: "2026-06-14-scale-hunter-spawns-and-improve-red-ball-encircl",
        date: "2026-06-14",
        title: "Scale Hunter spawns and improve red ball encirclement AI.",
        description: "Scale Hunter spawns and improve red ball encirclement AI.",
        category: "visual"
    },
    {
        id: "2026-06-14-add-hunter-mode-with-chasing-red-balls-and-full-",
        date: "2026-06-14",
        title: "Add Hunter mode with chasing red balls and full rankings integration.",
        description: "Add Hunter mode with chasing red balls and full rankings integration.",
        category: "gameplay"
    },
    {
        id: "2026-06-14-document-new-modes-and-features-in-readme-add-mi",
        date: "2026-06-14",
        title: "Document new modes and features in README; add missing News entries.",
        description: "Document new modes and features in README; add missing News entries.",
        category: "bug-fix"
    },
    {
        id: "2026-06-14-spin-snake-apples-in-place-while-they-move",
        date: "2026-06-14",
        title: "Spin Snake apples in place while they move.",
        description: "Spin Snake apples in place while they move.",
        category: "visual"
    },
    {
        id: "2026-06-14-add-s-m-h-d-timeout-durations-and-a-reduce-timeo",
        date: "2026-06-14",
        title: "Add s/m/h/d timeout durations and a reduce-timeout modal in Moderation.",
        description: "Add s/m/h/d timeout durations and a reduce-timeout modal in Moderation.",
        category: "visual"
    },
    {
        id: "2026-06-13-align-modes-search-and-filter-on-the-same-row-as",
        date: "2026-06-13",
        title: "Align modes search and filter on the same row as section titles.",
        description: "Align modes search and filter on the same row as section titles.",
        category: "visual"
    },
    {
        id: "2026-06-13-restore-modes-title-layout-and-scroll-the-modes-",
        date: "2026-06-13",
        title: "Restore MODES title layout and scroll the modes search bar with content.",
        description: "Restore MODES title layout and scroll the modes search bar with content.",
        category: "visual"
    },
    {
        id: "2026-06-13-restore-heat-side-bar-and-tint-full-cursor-by-te",
        date: "2026-06-13",
        title: "Restore Heat side bar and tint full cursor by temperature.",
        description: "Restore Heat side bar and tint full cursor by temperature.",
        category: "visual"
    },
    {
        id: "2026-06-13-show-heat-temperature-as-an-in-cursor-red-blue-g",
        date: "2026-06-13",
        title: "Show Heat temperature as an in-cursor red-blue gauge.",
        description: "Show Heat temperature as an in-cursor red-blue gauge.",
        category: "visual"
    },
    {
        id: "2026-06-13-fix-heat-ball-collisions-modes-layout-color-rush",
        date: "2026-06-13",
        title: "Fix Heat ball collisions, modes layout, Color Rush death FX, and MP s…",
        description: "Fix Heat ball collisions, modes layout, Color Rush death FX, and MP sort.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-poll-global-mode-visit-counts-every-5-seconds-on",
        date: "2026-06-13",
        title: "Poll global mode visit counts every 5 seconds on the modes screen.",
        description: "Poll global mode visit counts every 5 seconds on the modes screen.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-keep-return-button-visible-during-death-animatio",
        date: "2026-06-13",
        title: "Keep RETURN button visible during death animation and lose freeze.",
        description: "Keep RETURN button visible during death animation and lose freeze.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-fix-squashed-gameplay-canvas-on-ipad-by-syncing-",
        date: "2026-06-13",
        title: "Fix squashed gameplay canvas on iPad by syncing touch viewport sizing.",
        description: "Fix squashed gameplay canvas on iPad by syncing touch viewport sizing.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-store-global-mode-play-counts-on-server-and-impr",
        date: "2026-06-13",
        title: "Store global mode play counts on server and improve visit badge visib…",
        description: "Store global mode play counts on server and improve visit badge visibility.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-add-see-in-ranking-menu-action-and-close-button-",
        date: "2026-06-13",
        title: "Add See In Ranking menu action and close button to mode options.",
        description: "Add See In Ranking menu action and close button to mode options.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-fix-quick-restart-to-auto-restart-after-lose-ani",
        date: "2026-06-13",
        title: "Fix Quick Restart to auto-restart after lose animation or freeze inst…",
        description: "Fix Quick Restart to auto-restart after lose animation or freeze instead of showing Game Over.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-add-three-dot-menu-button-on-mode-cards-for-desc",
        date: "2026-06-13",
        title: "Add three-dot menu button on mode cards for Description, Preview, and…",
        description: "Add three-dot menu button on mode cards for Description, Preview, and Pin.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-duplicate-pinned-mode-cards-instead-of-moving-th",
        date: "2026-06-13",
        title: "Duplicate pinned mode cards instead of moving them, and improve mode …",
        description: "Duplicate pinned mode cards instead of moving them, and improve mode previews.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-add-pin-unpin-modes-larger-modals-and-sidebar-ac",
        date: "2026-06-13",
        title: "Add pin/unpin modes, larger modals, and sidebar active dot.",
        description: "Add pin/unpin modes, larger modals, and sidebar active dot.",
        category: "visual"
    },
    {
        id: "2026-06-13-sync-mode-best-score-from-rankings-widen-sidebar",
        date: "2026-06-13",
        title: "Sync mode Best Score from Rankings, widen sidebar, add mode Descripti…",
        description: "Sync mode Best Score from Rankings, widen sidebar, add mode Description/Preview.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-rewrite-mode-card-copy-with-vibe-first-text-and-",
        date: "2026-06-13",
        title: "Rewrite mode card copy with vibe-first text and device-aware controls.",
        description: "Rewrite mode card copy with vibe-first text and device-aware controls.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-make-heat-temperature-rise-and-fall-faster-for-t",
        date: "2026-06-13",
        title: "Make Heat temperature rise and fall faster for tighter balance.",
        description: "Make Heat temperature rise and fall faster for tighter balance.",
        category: "visual"
    },
    {
        id: "2026-06-13-add-heat-singleplayer-mode-with-temperature-bar-",
        date: "2026-06-13",
        title: "Add Heat singleplayer mode with temperature bar and progressive ball …",
        description: "Add Heat singleplayer mode with temperature bar and progressive ball spawns.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-sync-stats-records-from-rankings-add-deaths-and-",
        date: "2026-06-13",
        title: "Sync Stats records from Rankings; add Deaths and Favorite Mode cards.",
        description: "Sync Stats records from Rankings; add Deaths and Favorite Mode cards.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-snake-sp-moving-apples-for-1-score-with-trail-co",
        date: "2026-06-13",
        title: "Snake SP: moving apples for +1 score with trail collision.",
        description: "Snake SP: moving apples for +1 score with trail collision.",
        category: "visual"
    },
    {
        id: "2026-06-13-fix-browser-zoom-by-pinning-canvas-backing-store",
        date: "2026-06-13",
        title: "Fix browser zoom by pinning canvas backing store and mapping pointer …",
        description: "Fix browser zoom by pinning canvas backing store and mapping pointer via rendered rect.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-stack-notifications-vertically-with-smooth-reflo",
        date: "2026-06-13",
        title: "Stack notifications vertically with smooth reflow on dismiss.",
        description: "Stack notifications vertically with smooth reflow on dismiss.",
        category: "visual"
    },
    {
        id: "2026-06-13-show-play-count-badge-on-each-modes-screen-card",
        date: "2026-06-13",
        title: "Show play-count badge on each Modes screen card.",
        description: "Show play-count badge on each Modes screen card.",
        category: "visual"
    },
    {
        id: "2026-06-13-persist-modes-sort-filter-across-page-reloads",
        date: "2026-06-13",
        title: "Persist Modes sort filter across page reloads.",
        description: "Persist Modes sort filter across page reloads.",
        category: "visual"
    },
    {
        id: "2026-06-13-fix-zoom-ball-scale-via-layout-viewport-product-",
        date: "2026-06-13",
        title: "Fix zoom ball scale via layout viewport product and persist News filter.",
        description: "Fix zoom ball scale via layout viewport product and persist News filter.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-fix-gameplay-scale-at-extreme-browser-zoom-33-or",
        date: "2026-06-13",
        title: "Fix gameplay scale at extreme browser zoom (33% or less).",
        description: "Fix gameplay scale at extreme browser zoom (33% or less).",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-keep-balls-cursor-and-obstacles-stable-under-bro",
        date: "2026-06-13",
        title: "Keep balls, cursor, and obstacles stable under browser zoom.",
        description: "Keep balls, cursor, and obstacles stable under browser zoom.",
        category: "visual"
    },
    {
        id: "2026-06-13-style-modes-filter-dropdown-like-rankings-select",
        date: "2026-06-13",
        title: "Style Modes filter dropdown like Rankings select.",
        description: "Style Modes filter dropdown like Rankings select.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-randomize-color-rush-cursor-colors-without-conse",
        date: "2026-06-13",
        title: "Randomize Color Rush cursor colors without consecutive repeats.",
        description: "Randomize Color Rush cursor colors without consecutive repeats.",
        category: "visual"
    },
    {
        id: "2026-06-13-add-modes-search-sort-filters-and-play-count-pop",
        date: "2026-06-13",
        title: "Add Modes search, sort filters, and play-count popularity tracking.",
        description: "Add Modes search, sort filters, and play-count popularity tracking.",
        category: "visual"
    },
    {
        id: "2026-06-13-respawn-color-rush-balls-after-2s-with-cursor-sa",
        date: "2026-06-13",
        title: "Respawn Color Rush balls after 2s with cursor-safe placement.",
        description: "Respawn Color Rush balls after 2s with cursor-safe placement.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-move-color-rush-to-last-in-singleplayer-and-enab",
        date: "2026-06-13",
        title: "Move Color Rush to last in singleplayer and enable ball collisions.",
        description: "Move Color Rush to last in singleplayer and enable ball collisions.",
        category: "visual"
    },
    {
        id: "2026-06-13-add-color-rush-singleplayer-mode-with-color-matc",
        date: "2026-06-13",
        title: "Add Color Rush singleplayer mode with color-matching collection.",
        description: "Add Color Rush singleplayer mode with color-matching collection.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-remove-game-size-keep-balls-stable-on-browser-zo",
        date: "2026-06-13",
        title: "Remove Game Size, keep balls stable on browser zoom, and expand Moder…",
        description: "Remove Game Size, keep balls stable on browser zoom, and expand Moderation timeouts.",
        category: "visual"
    },
    {
        id: "2026-06-13-add-remove-timeout-action-in-moderation-for-clea",
        date: "2026-06-13",
        title: "Add Remove timeout action in Moderation for clearing active user time…",
        description: "Add Remove timeout action in Moderation for clearing active user timeouts.",
        category: "visual"
    },
    {
        id: "2026-06-13-fix-sidebar-layout-at-minimum-game-size-so-the-p",
        date: "2026-06-13",
        title: "Fix sidebar layout at minimum Game Size so the panel fills the left e…",
        description: "Fix sidebar layout at minimum Game Size so the panel fills the left edge with footer actions pinned at the bottom.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-keep-gameplay-scale-stable-under-browser-zoom-an",
        date: "2026-06-13",
        title: "Keep gameplay scale stable under browser zoom and add Settings Game S…",
        description: "Keep gameplay scale stable under browser zoom and add Settings Game Size for UI-only scaling.",
        category: "settings"
    },
    {
        id: "2026-06-13-raise-combo-mode-max-multiplier-to-262-144",
        date: "2026-06-13",
        title: "Raise Combo mode max multiplier to 262,144.",
        description: "Raise Combo mode max multiplier to 262,144.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-restore-rectangular-home-start-button-with-stron",
        date: "2026-06-13",
        title: "Restore rectangular Home START button with stronger glow.",
        description: "Restore rectangular Home START button with stronger glow.",
        category: "visual"
    },
    {
        id: "2026-06-13-fix-overload-50-score-applying-to-displayed-and-",
        date: "2026-06-13",
        title: "Fix Overload +50% score applying to displayed and saved score.",
        description: "Fix Overload +50% score applying to displayed and saved score.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-fix-overload-round-timer-reset-and-option-title-",
        date: "2026-06-13",
        title: "Fix Overload round timer reset and option title text color.",
        description: "Fix Overload round timer reset and option title text color.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-balance-overload-picks-trait-conflicts-life-loss",
        date: "2026-06-13",
        title: "Balance Overload picks: trait conflicts, life-loss debuffs, heart HUD.",
        description: "Balance Overload picks: trait conflicts, life-loss debuffs, heart HUD.",
        category: "visual"
    },
    {
        id: "2026-06-13-set-overload-round-timer-to-15-seconds",
        date: "2026-06-13",
        title: "Set Overload round timer to 15 seconds.",
        description: "Set Overload round timer to 15 seconds.",
        category: "visual"
    },
    {
        id: "2026-06-13-improve-overload-pick-overlay-blur-transparent-c",
        date: "2026-06-13",
        title: "Improve Overload pick overlay: blur, transparent cards, frozen cursor.",
        description: "Improve Overload pick overlay: blur, transparent cards, frozen cursor.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-add-overload-singleplayer-mode-with-timed-trade-",
        date: "2026-06-13",
        title: "Add Overload singleplayer mode with timed trade-off picks and lives.",
        description: "Add Overload singleplayer mode with timed trade-off picks and lives.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-match-home-start-and-title-glow-colors-to-button",
        date: "2026-06-13",
        title: "Match Home START and title glow colors to button and text settings.",
        description: "Match Home START and title glow colors to button and text settings.",
        category: "settings"
    },
    {
        id: "2026-06-13-isolate-sidebar-active-dot-from-button-press-ani",
        date: "2026-06-13",
        title: "Isolate sidebar active dot from button press animation and catch up N…",
        description: "Isolate sidebar active dot from button press animation and catch up News.",
        category: "visual"
    },
    {
        id: "2026-06-13-let-lobby-host-transfer-host-role-to-another-pla",
        date: "2026-06-13",
        title: "Let lobby host transfer host role to another player.",
        description: "Let lobby host transfer host role to another player.",
        category: "visual"
    },
    {
        id: "2026-06-13-avoid-spawning-mp-balls-within-clearance-of-ever",
        date: "2026-06-13",
        title: "Avoid spawning MP balls within clearance of every alive cursor.",
        description: "Avoid spawning MP balls within clearance of every alive cursor.",
        category: "visual"
    },
    {
        id: "2026-06-13-fix-snake-mp-trail-tunneling-with-swept-collisio",
        date: "2026-06-13",
        title: "Fix Snake MP trail tunneling with swept collision and spectate on hit.",
        description: "Fix Snake MP trail tunneling with swept collision and spectate on hit.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-fix-start-button-to-render-as-a-true-circle-on-a",
        date: "2026-06-13",
        title: "Fix START button to render as a true circle on all viewports.",
        description: "Fix START button to render as a true circle on all viewports.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-circular-start-button-sidebar-dot-outside-snake-",
        date: "2026-06-13",
        title: "Circular START button, sidebar dot outside, Snake MP trail fix, MP en…",
        description: "Circular START button, sidebar dot outside, Snake MP trail fix, MP end screens with Play Again.",
        category: "gameplay"
    },
    {
        id: "2026-06-13-show-active-sidebar-panel-indicator-as-a-small-b",
        date: "2026-06-13",
        title: "Show active sidebar panel indicator as a small button-colored dot.",
        description: "Show active sidebar panel indicator as a small button-colored dot.",
        category: "visual"
    },
    {
        id: "2026-06-13-remove-sidebar-button-outline-and-freeze-spawn-t",
        date: "2026-06-13",
        title: "Remove sidebar button outline and freeze spawn timers while paused.",
        description: "Remove sidebar button outline and freeze spawn timers while paused.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-add-pc-arrow-key-navigation-for-main-menu-sideba",
        date: "2026-06-13",
        title: "Add PC arrow-key navigation for main menu sidebar panels.",
        description: "Add PC arrow-key navigation for main menu sidebar panels.",
        category: "visual"
    },
    {
        id: "2026-06-13-add-triple-tap-quick-restart-for-pc-gameplay",
        date: "2026-06-13",
        title: "Add triple-tap quick restart for PC gameplay.",
        description: "Add triple-tap quick restart for PC gameplay.",
        category: "visual"
    },
    {
        id: "2026-06-13-fix-ball-collision-tunneling-at-high-cursor-spee",
        date: "2026-06-13",
        title: "Fix ball collision tunneling at high cursor speed.",
        description: "Fix ball collision tunneling at high cursor speed.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-fix-combo-ball-spawns-to-use-a-fixed-time-interv",
        date: "2026-06-13",
        title: "Fix Combo ball spawns to use a fixed time interval.",
        description: "Fix Combo ball spawns to use a fixed time interval.",
        category: "bug-fix"
    },
    {
        id: "2026-06-13-add-combo-mode-and-freeze-game-lose-setting",
        date: "2026-06-13",
        title: "Add Combo mode and Freeze Game lose setting.",
        description: "Add Combo mode and Freeze Game lose setting.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-sandbox-sp-return-routing-and-play-menu-musi",
        date: "2026-06-12",
        title: "Fix Sandbox SP Return routing and play menu music in MP lobby.",
        description: "Fix Sandbox SP Return routing and play menu music in MP lobby.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-add-friends-by-username-and-catch-up-news-entrie",
        date: "2026-06-12",
        title: "Add friends by username and catch up News entries.",
        description: "Add friends by username and catch up News entries.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-show-visible-play-border-in-snake-mode-only",
        date: "2026-06-12",
        title: "Show visible play border in Snake mode only.",
        description: "Show visible play border in Snake mode only.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-add-snake-mp-balls-on-off-toggle-in-lobby-game-s",
        date: "2026-06-12",
        title: "Add Snake MP Balls ON/OFF toggle in lobby game settings.",
        description: "Add Snake MP Balls ON/OFF toggle in lobby game settings.",
        category: "settings"
    },
    {
        id: "2026-06-12-rebuild-highway-mp-client-module-and-sync-snake-",
        date: "2026-06-12",
        title: "Rebuild Highway MP client module and sync snake trails for all viewers.",
        description: "Rebuild Highway MP client module and sync snake trails for all viewers.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-fix-create-room-friend-toggle-flow-and-restore-h",
        date: "2026-06-12",
        title: "Fix create-room friend toggle flow and restore Highway MP client sim.",
        description: "Fix create-room friend toggle flow and restore Highway MP client sim.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-snake-mp-trails-for-all-highway-mp-sync-and-frie",
        date: "2026-06-12",
        title: "Snake MP trails for all, Highway MP sync, and friend room invites.",
        description: "Snake MP trails for all, Highway MP sync, and friend room invites.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-snake-mp-free-movement-at-start-trails-after-3s-",
        date: "2026-06-12",
        title: "Snake MP: free movement at start, trails after 3s, fix PC cursor jump.",
        description: "Snake MP: free movement at start, trails after 3s, fix PC cursor jump.",
        category: "visual"
    },
    {
        id: "2026-06-12-snake-mp-3-second-start-countdown-before-trails-",
        date: "2026-06-12",
        title: "Snake MP: 3-second start countdown before trails appear or collide.",
        description: "Snake MP: 3-second start countdown before trails appear or collide.",
        category: "visual"
    },
    {
        id: "2026-06-12-add-snake-multiplayer-with-synced-permanent-trai",
        date: "2026-06-12",
        title: "Add Snake multiplayer with synced permanent trails and 50 balls per 5…",
        description: "Add Snake multiplayer with synced permanent trails and 50 balls per 500 score.",
        category: "visual"
    },
    {
        id: "2026-06-12-snake-spawn-55-balls-every-500-score-instead-of-",
        date: "2026-06-12",
        title: "Snake: spawn 55 balls every 500 score instead of 10 every 250.",
        description: "Snake: spawn 55 balls every 500 score instead of 10 every 250.",
        category: "visual"
    },
    {
        id: "2026-06-12-add-snake-singleplayer-mode-with-permanent-trail",
        date: "2026-06-12",
        title: "Add Snake singleplayer mode with permanent trail, self-collision, and…",
        description: "Add Snake singleplayer mode with permanent trail, self-collision, and scaling ball spawns.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-sync-speedrun-mp-animation-to-server-tick-so-las",
        date: "2026-06-12",
        title: "Sync Speedrun MP animation to server tick so lasers match for all pla…",
        description: "Sync Speedrun MP animation to server tick so lasers match for all players.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-fix-highway-mp-session-init-rendering-and-game-s",
        date: "2026-06-12",
        title: "Fix Highway MP session init, rendering, and game_start re-launch.",
        description: "Fix Highway MP session init, rendering, and game_start re-launch.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-speedrun-co-op-respawn-so-collected-points-r",
        date: "2026-06-12",
        title: "Fix Speedrun co-op respawn so collected points reset without resettin…",
        description: "Fix Speedrun co-op respawn so collected points reset without resetting timer.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-add-mp-game-settings-panel-speedrun-race-cursor-",
        date: "2026-06-12",
        title: "Add MP Game Settings panel, Speedrun race cursor toggle, and fix High…",
        description: "Add MP Game Settings panel, Speedrun race cursor toggle, and fix Highway MP sim.",
        category: "settings"
    },
    {
        id: "2026-06-12-fix-highway-mp-rendering-ffa-last-player-spectat",
        date: "2026-06-12",
        title: "Fix Highway MP rendering, FFA last-player spectate, and lobby Return …",
        description: "Fix Highway MP rendering, FFA last-player spectate, and lobby Return visibility.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-highway-mp-sync-game-state-collisions-score-",
        date: "2026-06-12",
        title: "Fix Highway MP sync: game_state, collisions, score, and lobby return.",
        description: "Fix Highway MP sync: game_state, collisions, score, and lobby return.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-highway-mp-collisions-sync-and-add-speedrun-",
        date: "2026-06-12",
        title: "Fix Highway MP collisions/sync and add Speedrun Race vs Co-op.",
        description: "Fix Highway MP collisions/sync and add Speedrun Race vs Co-op.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-highway-mp-remote-movement-host-return-sync-",
        date: "2026-06-12",
        title: "Fix Highway MP remote movement, host Return sync, and results UI.",
        description: "Fix Highway MP remote movement, host Return sync, and results UI.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-highway-mp-with-seeded-client-sim-and-speedr",
        date: "2026-06-12",
        title: "Fix Highway MP with seeded client sim and Speedrun results flow.",
        description: "Fix Highway MP with seeded client sim and Speedrun results flow.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-highway-mp-sync-speedrun-results-return-and-",
        date: "2026-06-12",
        title: "Fix Highway MP sync, Speedrun results Return, and spectate cursor.",
        description: "Fix Highway MP sync, Speedrun results Return, and spectate cursor.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-highway-mp-y-sync-speedrun-spectate-ui-and-m",
        date: "2026-06-12",
        title: "Fix Highway MP Y sync, Speedrun spectate UI, and MP Return to lobby.",
        description: "Fix Highway MP Y sync, Speedrun spectate UI, and MP Return to lobby.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-add-speedrun-mp-race-mode-with-ffa-countdown-and",
        date: "2026-06-12",
        title: "Add Speedrun MP race mode with FFA, countdown, and local collisions.",
        description: "Add Speedrun MP race mode with FFA, countdown, and local collisions.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-fix-multiplayer-mode-parity-wasd-sandbox-speedru",
        date: "2026-06-12",
        title: "Fix multiplayer mode parity: WASD, Sandbox, Speedrun, Highway, and ca…",
        description: "Fix multiplayer mode parity: WASD, Sandbox, Speedrun, Highway, and card sounds.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-improve-mode-selection-ux-and-fix-mp-highway-was",
        date: "2026-06-12",
        title: "Improve mode selection UX and fix MP Highway, WASD, and pointer lock.",
        description: "Improve mode selection UX and fix MP Highway, WASD, and pointer lock.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-block-admins-from-editing-their-own-permission-g",
        date: "2026-06-12",
        title: "Block admins from editing their own permission grants.",
        description: "Block admins from editing their own permission grants.",
        category: "visual"
    },
    {
        id: "2026-06-12-fix-mp-return-speedrun-levels-highway-controls-a",
        date: "2026-06-12",
        title: "Fix MP Return, Speedrun levels, Highway controls, and lobby layout.",
        description: "Fix MP Return, Speedrun levels, Highway controls, and lobby layout.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-fix-mp-lobby-select-only-highlights-mode-play-op",
        date: "2026-06-12",
        title: "Fix MP lobby: Select only highlights mode, Play opens setup.",
        description: "Fix MP lobby: Select only highlights mode, Play opens setup.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-restore-normal-mode-and-align-multiplayer-flows-",
        date: "2026-06-12",
        title: "Restore Normal mode and align multiplayer flows with singleplayer.",
        description: "Restore Normal mode and align multiplayer flows with singleplayer.",
        category: "gameplay"
    },
    {
        id: "2026-06-12-fix-multiplayer-lobby-select-mode-first-then-pla",
        date: "2026-06-12",
        title: "Fix multiplayer lobby: select mode first, then Play.",
        description: "Fix multiplayer lobby: select mode first, then Play.",
        category: "bug-fix"
    },
    {
        id: "2026-06-12-add-mp-trails-four-game-modes-lobby-sync-and-dis",
        date: "2026-06-12",
        title: "Add MP trails, four game modes, lobby sync, and disable pause.",
        description: "Add MP trails, four game modes, lobby sync, and disable pause.",
        category: "visual"
    },
    {
        id: "2026-06-12-smooth-multiplayer-motion-via-snapshot-interpola",
        date: "2026-06-12",
        title: "Smooth multiplayer motion via snapshot interpolation and fix phantom …",
        description: "Smooth multiplayer motion via snapshot interpolation and fix phantom deaths.",
        category: "visual"
    },
    {
        id: "2026-06-11-fix-multiplayer-hang-on-create-room-and-broken-r",
        date: "2026-06-11",
        title: "Fix multiplayer hang on Create Room and broken Render mp-server.",
        description: "Fix multiplayer hang on Create Room and broken Render mp-server.",
        category: "bug-fix"
    },
    {
        id: "2026-06-11-fix-ws-path-binding-for-render",
        date: "2026-06-11",
        title: "Fix ws path binding for render",
        description: "Fix ws path binding for render.",
        category: "bug-fix"
    },
    {
        id: "2026-06-11-fix-ws-logging",
        date: "2026-06-11",
        title: "Fix ws logging",
        description: "Fix ws logging.",
        category: "bug-fix"
    },
    {
        id: "2026-06-11-run-multiplayer-ws-as-a-separate-dev-process-wit",
        date: "2026-06-11",
        title: "Run multiplayer WS as a separate dev process with Vite proxy.",
        description: "Run multiplayer WS as a separate dev process with Vite proxy.",
        category: "visual"
    },
    {
        id: "2026-06-11-fix-create-room-by-attaching-the-dev-websocket-s",
        date: "2026-06-11",
        title: "Fix Create Room by attaching the dev WebSocket server after Vite starts.",
        description: "Fix Create Room by attaching the dev WebSocket server after Vite starts.",
        category: "bug-fix"
    },
    {
        id: "2026-06-11-add-websocket-multiplayer-with-rooms-lobby-and-n",
        date: "2026-06-11",
        title: "Add WebSocket multiplayer with rooms, lobby, and Normal FFA/Co-op.",
        description: "Add WebSocket multiplayer with rooms, lobby, and Normal FFA/Co-op.",
        category: "visual"
    },
    {
        id: "2026-06-11-add-mirror-mode-with-dual-cursors-reflected-acro",
        date: "2026-06-11",
        title: "Add Mirror mode with dual cursors reflected across screen center.",
        description: "Add Mirror mode with dual cursors reflected across screen center.",
        category: "gameplay"
    },
    {
        id: "2026-06-11-fix-settings-reset-so-missing-keys-use-factory-d",
        date: "2026-06-11",
        title: "Fix settings reset so missing keys use factory defaults instead of zero.",
        description: "Fix settings reset so missing keys use factory defaults instead of zero.",
        category: "bug-fix"
    },
    {
        id: "2026-06-11-rename-displayed-branding-from-retro-arcade-curs",
        date: "2026-06-11",
        title: "Rename displayed branding from Retro Arcade Cursor to CursorGame.",
        description: "Rename displayed branding from Retro Arcade Cursor to CursorGame.",
        category: "visual"
    },
    {
        id: "2026-06-11-configure-favicon-links-so-the-game-icon-appears",
        date: "2026-06-11",
        title: "Configure favicon links so the game icon appears in browser tabs and …",
        description: "Configure favicon links so the game icon appears in browser tabs and bookmarks.",
        category: "visual"
    },
    {
        id: "2026-06-11-scale-gameplay-mechanics-with-delta-time-for-fps",
        date: "2026-06-11",
        title: "Scale gameplay mechanics with delta time for FPS-independent speed.",
        description: "Scale gameplay mechanics with delta time for FPS-independent speed.",
        category: "visual"
    },
    {
        id: "2026-06-11-give-darkness-pickups-a-fixed-vision-boost-regar",
        date: "2026-06-11",
        title: "Give Darkness pickups a fixed vision boost regardless of circle size.",
        description: "Give Darkness pickups a fixed vision boost regardless of circle size.",
        category: "gameplay"
    },
    {
        id: "2026-06-11-add-missing-news-entries-for-recent-player-facin",
        date: "2026-06-11",
        title: "Add missing News entries for recent player-facing updates.",
        description: "Add missing News entries for recent player-facing updates.",
        category: "bug-fix"
    },
    {
        id: "2026-06-09-fix-return-clickability-and-sound-stack-undo-red",
        date: "2026-06-09",
        title: "Fix RETURN clickability and sound; stack Undo/Redo under Reset.",
        description: "Fix RETURN clickability and sound; stack Undo/Redo under Reset.",
        category: "bug-fix"
    },
    {
        id: "2026-06-09-move-screen-return-to-top-left-hud-and-add-setti",
        date: "2026-06-09",
        title: "Move screen RETURN to top-left HUD and add Settings reset with undo/r…",
        description: "Move screen RETURN to top-left HUD and add Settings reset with undo/redo.",
        category: "settings"
    },
    {
        id: "2026-06-09-fix-lose-animation-death-freeze-and-missing-game",
        date: "2026-06-09",
        title: "Fix lose animation death freeze and missing game over.",
        description: "Fix lose animation death freeze and missing game over.",
        category: "bug-fix"
    },
    {
        id: "2026-06-09-fix-death-freeze-and-missing-game-over-screen",
        date: "2026-06-09",
        title: "Fix death freeze and missing game over screen.",
        description: "Fix death freeze and missing game over screen.",
        category: "bug-fix"
    },
    {
        id: "2026-06-08-fix-loading-screen-stuck-by-removing-ui-cursor-h",
        date: "2026-06-08",
        title: "Fix LOADING screen stuck by removing ui-cursor-hints.",
        description: "Fix LOADING screen stuck by removing ui-cursor-hints.",
        category: "bug-fix"
    },
    {
        id: "2026-06-08-restore-pc-mouse-cursor-hints-pointer-grab-grabb",
        date: "2026-06-08",
        title: "Restore PC mouse cursor hints (pointer, grab, grabbing, text).",
        description: "Restore PC mouse cursor hints (pointer, grab, grabbing, text).",
        category: "visual"
    },
    {
        id: "2026-06-08-fix-loading-screen-stuck-when-auth-init-stalls-o",
        date: "2026-06-08",
        title: "Fix LOADING screen stuck when auth init stalls or init throws later.",
        description: "Fix LOADING screen stuck when auth init stalls or init throws later.",
        category: "bug-fix"
    },
    {
        id: "2026-06-08-revert-contextual-ui-cursor-hints-pointer-grab-g",
        date: "2026-06-08",
        title: "Revert contextual UI cursor hints (pointer, grab, grabbing, text).",
        description: "Revert contextual UI cursor hints (pointer, grab, grabbing, text).",
        category: "visual"
    },
    {
        id: "2026-06-08-fix-bootstrap-loading-screen-stuck-on-account-sy",
        date: "2026-06-08",
        title: "Fix bootstrap LOADING screen stuck on account sync.",
        description: "Fix bootstrap LOADING screen stuck on account sync.",
        category: "bug-fix"
    },
    {
        id: "2026-06-08-add-contextual-ui-cursors-and-align-open-sidebar",
        date: "2026-06-08",
        title: "Add contextual UI cursors and align open sidebar below CLOSE.",
        description: "Add contextual UI cursors and align open sidebar below CLOSE.",
        category: "visual"
    },
    {
        id: "2026-06-08-fix-start-button-blocked-by-home-interactive-bal",
        date: "2026-06-08",
        title: "Fix START button blocked by home interactive ball on touch.",
        description: "Fix START button blocked by home interactive ball on touch.",
        category: "bug-fix"
    },
    {
        id: "2026-06-08-show-menu-ambient-balls-on-all-screens-and-fix-h",
        date: "2026-06-08",
        title: "Show menu ambient balls on all screens and fix home ball layering.",
        description: "Show menu ambient balls on all screens and fix home ball layering.",
        category: "visual"
    },
    {
        id: "2026-06-08-fix-home-ball-throw-physics-and-align-ui-navigat",
        date: "2026-06-08",
        title: "Fix home ball throw physics and align UI navigation sounds.",
        description: "Fix home ball throw physics and align UI navigation sounds.",
        category: "bug-fix"
    },
    {
        id: "2026-06-08-add-ui-volume-home-interactive-ball-and-roulette",
        date: "2026-06-08",
        title: "Add UI volume, home interactive ball, and roulette cleanup.",
        description: "Add UI volume, home interactive ball, and roulette cleanup.",
        category: "settings"
    },
    {
        id: "2026-06-08-add-nav-progression-ui-sounds-and-fix-progressio",
        date: "2026-06-08",
        title: "Add nav/progression UI sounds and fix Progression pacing.",
        description: "Add nav/progression UI sounds and fix Progression pacing.",
        category: "gameplay"
    },
    {
        id: "2026-06-08-reorganize-settings-into-color-slider-and-toggle",
        date: "2026-06-08",
        title: "Reorganize Settings into color/slider and toggle groups.",
        description: "Reorganize Settings into color/slider and toggle groups.",
        category: "settings"
    },
    {
        id: "2026-06-08-raise-mobile-hud-under-status-bar-and-restore-fo",
        date: "2026-06-08",
        title: "Raise mobile HUD under status bar and restore footer on touch.",
        description: "Raise mobile HUD under status bar and restore footer on touch.",
        category: "visual"
    },
    {
        id: "2026-06-08-fix-ipad-pwa-layout-safe-top-inset-for-hud-and-f",
        date: "2026-06-08",
        title: "Fix iPad PWA layout: safe top inset for HUD and full-bleed viewport.",
        description: "Fix iPad PWA layout: safe top inset for HUD and full-bleed viewport.",
        category: "bug-fix"
    },
    {
        id: "2026-06-08-hide-keybinds-nav-on-mobile-remove-superdot-boun",
        date: "2026-06-08",
        title: "Hide Keybinds nav on mobile, remove SuperDot bounce boost, add Auto R…",
        description: "Hide Keybinds nav on mobile, remove SuperDot bounce boost, add Auto Retry.",
        category: "settings"
    },
    {
        id: "2026-06-07-restore-letter-o-in-cursorgame-home-title",
        date: "2026-06-07",
        title: "Restore letter O in CURSORGAME home title.",
        description: "Restore letter O in CURSORGAME home title.",
        category: "visual"
    },
    {
        id: "2026-06-07-center-home-title-cursor-between-s-and-r-add-set",
        date: "2026-06-07",
        title: "Center HOME title cursor between S and R; add Settings section nav.",
        description: "Center HOME title cursor between S and R; add Settings section nav.",
        category: "settings"
    },
    {
        id: "2026-06-07-add-settings-account-section-fix-bootstrap-loadi",
        date: "2026-06-07",
        title: "Add Settings Account section, fix bootstrap loading, and text-colored…",
        description: "Add Settings Account section, fix bootstrap loading, and text-colored home O.",
        category: "settings"
    },
    {
        id: "2026-06-07-replace-cursorgame-title-o-with-cursor-colored-b",
        date: "2026-06-07",
        title: "Replace CURSORGAME title O with cursor-colored ball from settings.",
        description: "Replace CURSORGAME title O with cursor-colored ball from settings.",
        category: "settings"
    },
    {
        id: "2026-06-07-add-accessibility-setting-to-disable-home-backgr",
        date: "2026-06-07",
        title: "Add Accessibility setting to disable Home background balls.",
        description: "Add Accessibility setting to disable Home background balls.",
        category: "settings"
    },
    {
        id: "2026-06-07-fix-home-start-sidebar-shift-mobile-hud-footer-a",
        date: "2026-06-07",
        title: "Fix Home START sidebar shift, mobile HUD/footer, and add Text Color s…",
        description: "Fix Home START sidebar shift, mobile HUD/footer, and add Text Color settings.",
        category: "bug-fix"
    },
    {
        id: "2026-06-07-polish-home-layout-user-line-under-title-ambient",
        date: "2026-06-07",
        title: "Polish Home layout: user line under title, ambient balls, mobile HUD …",
        description: "Polish Home layout: user line under title, ambient balls, mobile HUD and footer.",
        category: "visual"
    },
    {
        id: "2026-06-07-increase-home-cursorgame-title-size-and-scale-or",
        date: "2026-06-07",
        title: "Increase Home CURSORGAME title size and scale orbit to match.",
        description: "Increase Home CURSORGAME title size and scale orbit to match.",
        category: "visual"
    },
    {
        id: "2026-06-07-replace-home-play-title-with-top-cursorgame-bran",
        date: "2026-06-07",
        title: "Replace Home PLAY title with top CURSORGAME branding and orbiting cur…",
        description: "Replace Home PLAY title with top CURSORGAME branding and orbiting cursor.",
        category: "visual"
    },
    {
        id: "2026-06-07-isolate-account-sync-per-user-clear-local-data-o",
        date: "2026-06-07",
        title: "Isolate account sync per user; clear local data on switch and logout.",
        description: "Isolate account sync per user; clear local data on switch and logout.",
        category: "gameplay"
    },
    {
        id: "2026-06-07-fix-account-sync-polluting-existing-accounts-wit",
        date: "2026-06-07",
        title: "Fix account sync polluting existing accounts with local guest data.",
        description: "Fix account sync polluting existing accounts with local guest data.",
        category: "bug-fix"
    },
    {
        id: "2026-06-07-revert-add-forgot-password-flow-with-email-verif",
        date: "2026-06-07",
        title: "Revert \"Add forgot-password flow with email verification codes.\"",
        description: "Revert \"Add forgot-password flow with email verification codes.\".",
        category: "visual"
    },
    {
        id: "2026-06-07-revert-fix-password-reset-email-delivery-with-re",
        date: "2026-06-07",
        title: "Revert \"Fix password reset email delivery with Resend and SMTP fallba…",
        description: "Revert \"Fix password reset email delivery with Resend and SMTP fallback.\".",
        category: "visual"
    },
    {
        id: "2026-06-06-fix-password-reset-email-delivery-with-resend-an",
        date: "2026-06-06",
        title: "Fix password reset email delivery with Resend and SMTP fallback.",
        description: "Fix password reset email delivery with Resend and SMTP fallback.",
        category: "bug-fix"
    },
    {
        id: "2026-06-06-add-forgot-password-flow-with-email-verification",
        date: "2026-06-06",
        title: "Add forgot-password flow with email verification codes.",
        description: "Add forgot-password flow with email verification codes.",
        category: "visual"
    },
    {
        id: "2026-06-06-fix-mobile-bottom-black-gap-by-filling-full-view",
        date: "2026-06-06",
        title: "Fix mobile bottom black gap by filling full viewport height.",
        description: "Fix mobile bottom black gap by filling full viewport height.",
        category: "bug-fix"
    },
    {
        id: "2026-06-06-remove-mobile-top-bar-nudge-menu-return-and-paus",
        date: "2026-06-06",
        title: "Remove mobile top bar; nudge Menu, Return, and Pause down slightly.",
        description: "Remove mobile top bar; nudge Menu, Return, and Pause down slightly.",
        category: "visual"
    },
    {
        id: "2026-06-06-fix-mobile-canvas-shrinking-to-top-left-corner",
        date: "2026-06-06",
        title: "Fix mobile canvas shrinking to top-left corner.",
        description: "Fix mobile canvas shrinking to top-left corner.",
        category: "bug-fix"
    },
    {
        id: "2026-06-06-sync-account-records-stats-settings-and-achievem",
        date: "2026-06-06",
        title: "Sync account records, stats, settings, and achievements across devices.",
        description: "Sync account records, stats, settings, and achievements across devices.",
        category: "settings"
    },
    {
        id: "2026-06-06-fix-mobile-safe-area-bar-rendering-at-top-instea",
        date: "2026-06-06",
        title: "Fix mobile safe-area bar rendering at top instead of bottom gap.",
        description: "Fix mobile safe-area bar rendering at top instead of bottom gap.",
        category: "bug-fix"
    },
    {
        id: "2026-06-06-fix-mobile-pwa-safe-area-bar-at-top-with-content",
        date: "2026-06-06",
        title: "Fix mobile PWA safe-area bar at top with content flush below.",
        description: "Fix mobile PWA safe-area bar at top with content flush below.",
        category: "bug-fix"
    },
    {
        id: "2026-06-05-cap-highway-mode-max-speed-at-5000-points",
        date: "2026-06-05",
        title: "Cap Highway mode max speed at 5000 points.",
        description: "Cap Highway mode max speed at 5000 points.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-lower-mobile-menu-pause-and-return-below-status-",
        date: "2026-06-05",
        title: "Lower mobile Menu, Pause, and Return below status bar.",
        description: "Lower mobile Menu, Pause, and Return below status bar.",
        category: "visual"
    },
    {
        id: "2026-06-05-push-mobile-hud-controls-below-status-bar-with-e",
        date: "2026-06-05",
        title: "Push mobile HUD controls below status bar with extra top gap.",
        description: "Push mobile HUD controls below status bar with extra top gap.",
        category: "visual"
    },
    {
        id: "2026-06-05-add-black-safe-area-top-bar-for-mobile-pwa-stand",
        date: "2026-06-05",
        title: "Add black safe-area top bar for mobile PWA standalone mode.",
        description: "Add black safe-area top bar for mobile PWA standalone mode.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-fix-pwa-icon-filenames-by-removing-duplicate-png",
        date: "2026-06-05",
        title: "Fix PWA icon filenames by removing duplicate .png extension.",
        description: "Fix PWA icon filenames by removing duplicate .png extension.",
        category: "bug-fix"
    },
    {
        id: "2026-06-05-add-pwa-support-with-offline-leaderboard-sync-fo",
        date: "2026-06-05",
        title: "Add PWA support with offline leaderboard sync for CursorGame.",
        description: "Add PWA support with offline leaderboard sync for CursorGame.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-add-deaths-playtime-rankings-optional-keybinds-w",
        date: "2026-06-05",
        title: "Add Deaths/PlayTime rankings, optional keybinds, wider settings cards.",
        description: "Add Deaths/PlayTime rankings, optional keybinds, wider settings cards.",
        category: "settings"
    },
    {
        id: "2026-06-05-add-cursor-split-lose-animation-with-crack-sound",
        date: "2026-06-05",
        title: "Add cursor split lose animation with crack sound.",
        description: "Add cursor split lose animation with crack sound.",
        category: "visual"
    },
    {
        id: "2026-06-05-lighten-death-vfx-to-reduce-fps-spikes-on-game-o",
        date: "2026-06-05",
        title: "Lighten death VFX to reduce FPS spikes on game over.",
        description: "Lighten death VFX to reduce FPS spikes on game over.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-restrict-full-screen-layout-to-messages-only",
        date: "2026-06-05",
        title: "Restrict full-screen layout to Messages only.",
        description: "Restrict full-screen layout to Messages only.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-improve-death-burst-particles-with-cursor-colore",
        date: "2026-06-05",
        title: "Improve death burst particles with cursor-colored glow.",
        description: "Improve death burst particles with cursor-colored glow.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-add-customizable-return-pause-and-menu-keybinds-",
        date: "2026-06-05",
        title: "Add customizable Return, Pause, and Menu keybinds in Settings.",
        description: "Add customizable Return, Pause, and Menu keybinds in Settings.",
        category: "settings"
    },
    {
        id: "2026-06-05-widen-settings-cards-only-when-content-overflows",
        date: "2026-06-05",
        title: "Widen Settings cards only when content overflows.",
        description: "Widen Settings cards only when content overflows.",
        category: "settings"
    },
    {
        id: "2026-06-05-restore-settings-layout-to-original-width-and-gr",
        date: "2026-06-05",
        title: "Restore Settings layout to original width and grid.",
        description: "Restore Settings layout to original width and grid.",
        category: "settings"
    },
    {
        id: "2026-06-05-widen-settings-cards-based-on-content-density",
        date: "2026-06-05",
        title: "Widen Settings cards based on content density.",
        description: "Widen Settings cards based on content density.",
        category: "settings"
    },
    {
        id: "2026-06-05-fix-nav-section-layout-issues-and-achievements-m",
        date: "2026-06-05",
        title: "Fix nav section layout issues and Achievements music/performance.",
        description: "Fix nav section layout issues and Achievements music/performance.",
        category: "bug-fix"
    },
    {
        id: "2026-06-05-make-sidebar-nav-sections-full-screen-views-with",
        date: "2026-06-05",
        title: "Make sidebar nav sections full-screen views with smooth sidebar trans…",
        description: "Make sidebar nav sections full-screen views with smooth sidebar transitions.",
        category: "visual"
    },
    {
        id: "2026-06-05-restore-settings-grid-to-three-cards-per-row-on-",
        date: "2026-06-05",
        title: "Restore Settings grid to three cards per row on desktop.",
        description: "Restore Settings grid to three cards per row on desktop.",
        category: "settings"
    },
    {
        id: "2026-06-05-fix-settings-paste-to-reload-globals-after-impor",
        date: "2026-06-05",
        title: "Fix settings paste to reload globals after importing effect toggles.",
        description: "Fix settings paste to reload globals after importing effect toggles.",
        category: "bug-fix"
    },
    {
        id: "2026-06-05-reorganize-settings-into-individual-cards-with-s",
        date: "2026-06-05",
        title: "Reorganize Settings into individual cards with split effect toggles.",
        description: "Reorganize Settings into individual cards with split effect toggles.",
        category: "settings"
    },
    {
        id: "2026-06-05-tune-highway-speed-density-and-track-only-obstac",
        date: "2026-06-05",
        title: "Tune HIGHWAY speed, density, and track-only obstacles.",
        description: "Tune HIGHWAY speed, density, and track-only obstacles.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-game-over-in-highway-when-cursor-leaves-track-si",
        date: "2026-06-05",
        title: "Game over in HIGHWAY when cursor leaves track sides.",
        description: "Game over in HIGHWAY when cursor leaves track sides.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-cap-highway-camera-speed-doublings-at-5000-point",
        date: "2026-06-05",
        title: "Cap HIGHWAY camera speed doublings at 5000 points.",
        description: "Cap HIGHWAY camera speed doublings at 5000 points.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-double-highway-camera-speed-every-1000-points-up",
        date: "2026-06-05",
        title: "Double HIGHWAY camera speed every 1000 points up to 10k.",
        description: "Double HIGHWAY camera speed every 1000 points up to 10k.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-fix-highway-cursor-to-use-world-coords-independe",
        date: "2026-06-05",
        title: "Fix HIGHWAY cursor to use world coords independent of camera.",
        description: "Fix HIGHWAY cursor to use world coords independent of camera.",
        category: "bug-fix"
    },
    {
        id: "2026-06-05-add-highway-mode-with-infinite-upward-camera-scr",
        date: "2026-06-05",
        title: "Add HIGHWAY mode with infinite upward camera scroll.",
        description: "Add HIGHWAY mode with infinite upward camera scroll.",
        category: "gameplay"
    },
    {
        id: "2026-06-05-revert-sidebar-to-flat-scroll-navigation",
        date: "2026-06-05",
        title: "Revert sidebar to flat scroll navigation.",
        description: "Revert sidebar to flat scroll navigation.",
        category: "visual"
    },
    {
        id: "2026-06-05-fix-sidebar-wheel-alignment-clicks-and-tick-soun",
        date: "2026-06-05",
        title: "Fix sidebar wheel alignment, clicks, and tick sounds.",
        description: "Fix sidebar wheel alignment, clicks, and tick sounds.",
        category: "bug-fix"
    },
    {
        id: "2026-06-05-split-menu-game-background-colors-with-dark-mode",
        date: "2026-06-05",
        title: "Split menu/game background colors with Dark Mode and add 3D sidebar w…",
        description: "Split menu/game background colors with Dark Mode and add 3D sidebar wheel.",
        category: "settings"
    },
    {
        id: "2026-05-09-superdot-hud-ordered-skill-row-desktop-keys-alwa",
        date: "2026-05-09",
        title: "SuperDot HUD: ordered skill row, desktop keys always visible",
        description: "SuperDot HUD: ordered skill row, desktop keys always visible.",
        category: "gameplay"
    },
    {
        id: "2026-05-09-superdot-50-balls-per-500-points-1-5x-speed-boos",
        date: "2026-05-09",
        title: "SuperDot: 50 balls per 500 points, 1.5x speed boost on bounce",
        description: "SuperDot: 50 balls per 500 points, 1.5x speed boost on bounce.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-superdot-nueva-habilidad-barrier-w-con-cooldown-",
        date: "2026-05-08",
        title: "Superdot: nueva habilidad Barrier (W) con cooldown 30s y rebote de bolas",
        description: "Superdot: nueva habilidad Barrier (W) con cooldown 30s y rebote de bolas.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-speedrun-goal-collision-fix-at-high-speed",
        date: "2026-05-08",
        title: "SpeedRun goal collision fix at high speed",
        description: "Fixed passing through the goal cube when moving very fast in SpeedRun.",
        category: "bug-fix"
    },
    {
        id: "2026-05-08-speedrun-requires-mandatory-points",
        date: "2026-05-08",
        title: "SpeedRun requires mandatory points",
        description: "You must collect all required points before you can finish the goal in SpeedRun.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-top-lighting-matches-button-color",
        date: "2026-05-08",
        title: "Top lighting matches button color",
        description: "HUD top lighting now follows your button theme color instead of fixed cyan.",
        category: "visual"
    },
    {
        id: "2026-05-08-achievement-unlock-toast",
        date: "2026-05-08",
        title: "Achievement unlock toast",
        description: "Unlocking an achievement shows a short animated card below Pause for five seconds.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-enable-scrolling-on-achievements-screen-flex-ove",
        date: "2026-05-08",
        title: "Enable scrolling on Achievements screen (flex overflow)",
        description: "Enable scrolling on Achievements screen (flex overflow).",
        category: "gameplay"
    },
    {
        id: "2026-05-08-achievements-defs-threw-at-import-100-count-mism",
        date: "2026-05-08",
        title: "Achievements defs threw at import (100-count mismatch), breaking Menu…",
        description: "Achievements defs threw at import (100-count mismatch), breaking Menu/START/E.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-achievements-screen-100-goals-remove-menu-blink-",
        date: "2026-05-08",
        title: "Achievements screen (100 goals), remove menu blink, soften motion, sy…",
        description: "Achievements screen (100 goals), remove menu blink, soften motion, sync sidebar glow with button color.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-scope-menu-blink-to-content-pane-soften-effect-r",
        date: "2026-05-08",
        title: "Scope menu blink to content pane, soften effect, respect Special Effe…",
        description: "Scope menu blink to content pane, soften effect, respect Special Effects off.",
        category: "visual"
    },
    {
        id: "2026-05-08-letterbox-blink-when-opening-menu-sections-home-",
        date: "2026-05-08",
        title: "Letterbox blink when opening menu sections (Home, Settings, Rankings,…",
        description: "Letterbox blink when opening menu sections (Home, Settings, Rankings, etc.).",
        category: "settings"
    },
    {
        id: "2026-05-08-glitch-transition-when-opening-closing-settings",
        date: "2026-05-08",
        title: "Glitch transition when opening/closing Settings",
        description: "Glitch transition when opening/closing Settings.",
        category: "settings"
    },
    {
        id: "2026-05-08-settings-accordions-smooth-collapse-expand-slide",
        date: "2026-05-08",
        title: "Settings accordions: smooth collapse/expand (slide up) with JS + grid.",
        description: "Settings accordions: smooth collapse/expand (slide up) with JS + grid.",
        category: "settings"
    },
    {
        id: "2026-05-08-settings-accordion-sections-for-accessibility-ap",
        date: "2026-05-08",
        title: "Settings: accordion sections for Accessibility, Appearance, Sound.",
        description: "Settings: accordion sections for Accessibility, Appearance, Sound.",
        category: "settings"
    },
    {
        id: "2026-05-08-hud-cursor-overlay-draw-cursor-on-top-canvas-in-",
        date: "2026-05-08",
        title: "HUD cursor overlay: draw cursor on top canvas in all gameplay modes.",
        description: "HUD cursor overlay: draw cursor on top canvas in all gameplay modes.",
        category: "visual"
    },
    {
        id: "2026-05-08-roulette-draw-cursor-on-overlay-canvas-above-hud",
        date: "2026-05-08",
        title: "Roulette: draw cursor on overlay canvas above HUD text; balls stay be…",
        description: "Roulette: draw cursor on overlay canvas above HUD text; balls stay below.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-roulette-score-hud-fixed-bottom-center-always-vi",
        date: "2026-05-08",
        title: "Roulette: score HUD fixed bottom center, always visible (no fade vs e…",
        description: "Roulette: score HUD fixed bottom center, always visible (no fade vs effects).",
        category: "gameplay"
    },
    {
        id: "2026-05-08-stats-speedrun-card-shrink-font-to-fit-one-line-",
        date: "2026-05-08",
        title: "STATS SpeedRun card: shrink font to fit one line, nowrap.",
        description: "STATS SpeedRun card: shrink font to fit one line, nowrap.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-spawn-obstacles-outside-cursor-clearance-all-bal",
        date: "2026-05-08",
        title: "Spawn obstacles outside cursor clearance (all ball modes).",
        description: "Spawn obstacles outside cursor clearance (all ball modes).",
        category: "visual"
    },
    {
        id: "2026-05-08-stats-speedrun-card-in-grid-next-to-sandbox-time",
        date: "2026-05-08",
        title: "STATS: SPEEDRUN card in grid next to Sandbox; time, level dropdown, TOP.",
        description: "STATS: SPEEDRUN card in grid next to Sandbox; time, level dropdown, TOP.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-game-over-new-record-line-with-glow-animation-wh",
        date: "2026-05-08",
        title: "Game Over: NEW RECORD line with glow animation when beating local best.",
        description: "Game Over: NEW RECORD line with glow animation when beating local best.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-roulette-hud-show-score-under-countdown-with-cro",
        date: "2026-05-08",
        title: "Roulette HUD: show Score under countdown with crossfade vs effect label.",
        description: "Roulette HUD: show Score under countdown with crossfade vs effect label.",
        category: "gameplay"
    },
    {
        id: "2026-05-08-stats-grid-cards-with-records-and-cloud-top-rank",
        date: "2026-05-08",
        title: "STATS: grid cards with records and cloud TOP rank via myRank API.",
        description: "STATS: grid cards with records and cloud TOP rank via myRank API.",
        category: "visual"
    },
    {
        id: "2026-05-05-scale-gameplay-elements-with-viewport-lasers-bal",
        date: "2026-05-05",
        title: "Scale gameplay elements with viewport (lasers, balls, cursor, speedru…",
        description: "Scale gameplay elements with viewport (lasers, balls, cursor, speedrun props).",
        category: "gameplay"
    },
    {
        id: "2026-05-05-add-neon-balls-toggle",
        date: "2026-05-05",
        title: "Add Neon Balls toggle",
        description: "Add Neon Balls toggle.",
        category: "settings"
    },
    {
        id: "2026-05-05-toggle-auto-contrast-button-text",
        date: "2026-05-05",
        title: "Toggle auto-contrast button text",
        description: "Toggle auto-contrast button text.",
        category: "settings"
    },
    {
        id: "2026-05-04-magnet-pull-speed-follows-balls-speed-slider",
        date: "2026-05-04",
        title: "Magnet pull speed follows Balls Speed slider",
        description: "Magnet pull speed follows Balls Speed slider.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-roulette-flashbang-silence-music-1s-then-2s-fade",
        date: "2026-05-04",
        title: "Roulette Flashbang: silence music 1s then 2s fade-in from hit",
        description: "Roulette Flashbang: silence music 1s then 2s fade-in from hit.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-roulette-restore-big-cursor-x5-x10-remove-fast-c",
        date: "2026-05-04",
        title: "Roulette: restore big cursor x5/x10, remove fast cursor effect",
        description: "Roulette: restore big cursor x5/x10, remove fast cursor effect.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-roulette-flashbang-2s-beep-with-fade-duck-music-",
        date: "2026-05-04",
        title: "Roulette Flashbang: 2s beep with fade; duck music after beep ends",
        description: "Roulette Flashbang: 2s beep with fade; duck music after beep ends.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-roulette-remove-big-cursor-fat-cursor-random-eff",
        date: "2026-05-04",
        title: "Roulette: remove big-cursor (fat cursor) random effects",
        description: "Roulette: remove big-cursor (fat cursor) random effects.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-roulette-fixed-ball-speed-spawn-flashbang-audio-",
        date: "2026-05-04",
        title: "Roulette: fixed ball speed/spawn, flashbang audio duck, death music duck",
        description: "Roulette: fixed ball speed/spawn, flashbang audio duck, death music duck.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-show-username-above-start-button-text-active-sta",
        date: "2026-05-04",
        title: "Show username above START; button text + active states from luminance",
        description: "Show username above START; button text + active states from luminance.",
        category: "visual"
    },
    {
        id: "2026-05-04-roulette-magnet-pull-much-faster-sandbox-magnet-",
        date: "2026-05-04",
        title: "Roulette: magnet pull much faster; sandbox magnet unchanged",
        description: "Roulette: magnet pull much faster; sandbox magnet unchanged.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-compact-sandbox-preset-list",
        date: "2026-05-04",
        title: "Compact sandbox preset list",
        description: "Sandbox presets list shows name, author, and top score in a tighter layout.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-sandbox-cloud-delete-and-compact-list",
        date: "2026-05-04",
        title: "Sandbox cloud delete and compact list",
        description: "Delete sandbox presets from the cloud and use compact buttons in the preset list.",
        category: "gameplay"
    },
    {
        id: "2026-05-04-sandbox-speedrun-hud-and-preset-leaderboards",
        date: "2026-05-04",
        title: "Sandbox SpeedRun HUD and preset leaderboards",
        description: "Sandbox SpeedRun shows a timer HUD, per-preset leaderboards, and preset info.",
        category: "gameplay"
    },
    {
        id: "2026-05-03-sticky-rails-on-moving-walls",
        date: "2026-05-03",
        title: "Sticky rails on moving walls",
        description: "Moving wall rails can be sticky or allow sliding movement in SpeedRun.",
        category: "gameplay"
    },
    {
        id: "2026-05-03-sin-pegado-en-solidos-animados-sin-sticky-sesgo-",
        date: "2026-05-03",
        title: "Sin pegado en solidos animados sin sticky — sesgo de escape segun int…",
        description: "Sin pegado en solidos animados sin sticky — sesgo de escape segun intencion.",
        category: "visual"
    },
    {
        id: "2026-05-03-optional-sticky-speedrun-walls",
        date: "2026-05-03",
        title: "Optional sticky SpeedRun walls",
        description: "Moving walls can be sticky or slippery in SpeedRun for smoother movement when sticky is off.",
        category: "gameplay"
    },
    {
        id: "2026-05-03-ccd-sincronizado-cursor-pared-y-separacion-barri",
        date: "2026-05-03",
        title: "CCD sincronizado cursor-pared y separacion barrida en solidos animados",
        description: "CCD sincronizado cursor-pared y separacion barrida en solidos animados.",
        category: "visual"
    },
    {
        id: "2026-05-03-fix-tunneling-through-moving-walls",
        date: "2026-05-03",
        title: "Fix tunneling through moving walls",
        description: "Fixed slipping through animated solid walls between frames in SpeedRun.",
        category: "bug-fix"
    },
    {
        id: "2026-05-03-settings-pc-show-keybind-indicator-on-por-defect",
        date: "2026-05-03",
        title: "Settings (PC): Show keybind indicator ON por defecto",
        description: "Settings (PC): Show keybind indicator ON por defecto.",
        category: "settings"
    },
    {
        id: "2026-05-02-mobile-sidebar-scroll-fix",
        date: "2026-05-02",
        title: "Mobile sidebar scroll fix",
        description: "The sidebar scrolls correctly on mobile devices.",
        category: "visual"
    },
    {
        id: "2026-05-02-default-button-color-fix",
        date: "2026-05-02",
        title: "Default button color fix",
        description: "Default button color is cyan again and invalid hex values no longer turn white.",
        category: "bug-fix"
    },
    {
        id: "2026-05-02-sidebar-button-outline-removed",
        date: "2026-05-02",
        title: "Sidebar button outline removed",
        description: "Removed the focus outline on sidebar buttons for a cleaner look.",
        category: "visual"
    },
    {
        id: "2026-05-02-sidebar-press-shimmer",
        date: "2026-05-02",
        title: "Sidebar press shimmer",
        description: "Sidebar buttons shimmer when pressed and the active state no longer uses purple.",
        category: "bug-fix"
    },
    {
        id: "2026-05-02-css-selects-forminput-y-filas-ranking-speedrun-l",
        date: "2026-05-02",
        title: "CSS: selects formInput y filas ranking (SpeedRun level) coherentes",
        description: "CSS: selects formInput y filas ranking (SpeedRun level) coherentes.",
        category: "gameplay"
    },
    {
        id: "2026-05-02-ui-atmosphere-and-optional-vignette",
        date: "2026-05-02",
        title: "UI atmosphere and optional vignette",
        description: "Added UI atmosphere and an optional canvas vignette when visual effects are enabled.",
        category: "visual"
    },
    {
        id: "2026-05-02-return-button-matches-pause-style",
        date: "2026-05-02",
        title: "Return button matches Pause style",
        description: "Return uses the same transparent Pause style with a border in your button color.",
        category: "visual"
    },
    {
        id: "2026-05-02-cursor-misma-respuesta-que-normal-en-sandbox-rou",
        date: "2026-05-02",
        title: "Cursor: misma respuesta que Normal en sandbox/roulette/speedrun (salv…",
        description: "Cursor: misma respuesta que Normal en sandbox/roulette/speedrun (salvo efectos ruleta y ajustes sandbox).",
        category: "gameplay"
    },
    {
        id: "2026-05-02-beep-en-cada-paso-del-contador-3-2-1-al-resume",
        date: "2026-05-02",
        title: "Beep en cada paso del contador 3-2-1 al resume",
        description: "Beep en cada paso del contador 3-2-1 al resume.",
        category: "visual"
    },
    {
        id: "2026-05-02-pause-and-resume-sounds",
        date: "2026-05-02",
        title: "Pause and resume sounds",
        description: "Pausing plays an ascending chirp; resuming plays a descending chirp.",
        category: "visual"
    },
    {
        id: "2026-05-02-ten-chip-music-tracks",
        date: "2026-05-02",
        title: "Ten chip music tracks",
        description: "Menu and game music now include ten chip tracks with five new melodies.",
        category: "settings"
    },
    {
        id: "2026-05-02-music-section-in-settings",
        date: "2026-05-02",
        title: "Music section in Settings",
        description: "Pick separate menu and game music tracks from the new Music section in Settings.",
        category: "settings"
    },
    {
        id: "2026-05-02-speedrun-mostrar-mejor-tiempo-del-ranking-api-mi",
        date: "2026-05-02",
        title: "SpeedRun: mostrar mejor tiempo del ranking (API mine) en HUD y STATS",
        description: "SpeedRun: mostrar mejor tiempo del ranking (API mine) en HUD y STATS.",
        category: "gameplay"
    },
    {
        id: "2026-05-02-ajustes-joystick-flotante-on-off-y-visible-en-se",
        date: "2026-05-02",
        title: "Ajustes Joystick flotante ON/OFF y Visible en Settings",
        description: "Ajustes Joystick flotante ON/OFF y Visible en Settings.",
        category: "settings"
    },
    {
        id: "2026-05-02-speedrun-picker-cleanup",
        date: "2026-05-02",
        title: "SpeedRun picker cleanup",
        description: "Removed extra text from the SpeedRun level picker and aligned in-game UI copy to English.",
        category: "gameplay"
    },
    {
        id: "2026-05-02-return-y-pause-empiezan-a-transparentarse-desde-",
        date: "2026-05-02",
        title: "Return y Pause empiezan a transparentarse desde mas lejos",
        description: "Return y Pause empiezan a transparentarse desde mas lejos.",
        category: "visual"
    },
    {
        id: "2026-05-01-ancho-fijo-del-messages-messages-y-wrap-en-burbu",
        date: "2026-05-01",
        title: "Ancho fijo del messages Messages y wrap en burbujas",
        description: "Ancho fijo del messages Messages y wrap en burbujas.",
        category: "gameplay"
    },
    {
        id: "2026-05-01-sonido-tipo-moneda-al-coger-punto-en-speedrun",
        date: "2026-05-01",
        title: "Sonido tipo moneda al coger punto en SpeedRun",
        description: "Sonido tipo moneda al coger punto en SpeedRun.",
        category: "gameplay"
    },
    {
        id: "2026-05-01-return-and-pause-fade-on-mobile",
        date: "2026-05-01",
        title: "Return and Pause fade on mobile",
        description: "Return and Pause buttons fade by cursor proximity on mobile too.",
        category: "visual"
    },
    {
        id: "2026-05-01-return-pause-invisibles-bajo-el-cursor-opacidad-",
        date: "2026-05-01",
        title: "Return/Pause invisibles bajo el cursor; opacidad por distancia (viewp…",
        description: "Return/Pause invisibles bajo el cursor; opacidad por distancia (viewport).",
        category: "visual"
    },
    {
        id: "2026-05-01-settings-copy-and-paste-buttons",
        date: "2026-05-01",
        title: "Settings copy and paste buttons",
        description: "Copy and Paste for settings sit next to Return on the bottom bar.",
        category: "settings"
    },
    {
        id: "2026-04-30-fix-keydown-without-e-key-unlock-audio-only-on-t",
        date: "2026-04-30",
        title: "Fix keydown without e.key; unlock audio only on trusted pointer/touch…",
        description: "Fix keydown without e.key; unlock audio only on trusted pointer/touch (no keydown resume).",
        category: "bug-fix"
    },
    {
        id: "2026-04-30-respect-autoplay-policy-no-resume-play-until-run",
        date: "2026-04-30",
        title: "Respect autoplay policy — no resume/play until running, remove mousem…",
        description: "Respect autoplay policy — no resume/play until running, remove mousemove spam.",
        category: "visual"
    },
    {
        id: "2026-04-30-speedrun-sealed-corridor-frame-2-20-smoother-poi",
        date: "2026-04-30",
        title: "SpeedRun: sealed corridor frame (2-20); smoother pointer-lock cursor",
        description: "SpeedRun: sealed corridor frame (2-20); smoother pointer-lock cursor.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-roulette-magnet-effect-sandbox-magnet-on-off-tog",
        date: "2026-04-30",
        title: "Roulette: Magnet effect; Sandbox: Magnet ON/OFF toggle",
        description: "Roulette: Magnet effect; Sandbox: Magnet ON/OFF toggle.",
        category: "settings"
    },
    {
        id: "2026-04-30-message-toast-always-while-playing-pause-death-f",
        date: "2026-04-30",
        title: "Message toast: always while playing (pause/death), faster poll, above…",
        description: "Message toast: always while playing (pause/death), faster poll, above pause UI.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-superdot-touch-skill-buttons-draggable-layout-on",
        date: "2026-04-30",
        title: "SuperDot: touch skill buttons, draggable layout on mobile, MENU witho…",
        description: "SuperDot: touch skill buttons, draggable layout on mobile, MENU without [E] on touch.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-speedrun-add-play-again-on-level-complete-screen",
        date: "2026-04-30",
        title: "SpeedRun: add Play Again on level complete screen",
        description: "SpeedRun: add Play Again on level complete screen.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-speedrun-completion-title-matches-copy-spec",
        date: "2026-04-30",
        title: "SpeedRun completion title matches copy spec",
        description: "SpeedRun completion title matches copy spec.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-add-speedrun-maze-mode-with-10-levels-local-best",
        date: "2026-04-30",
        title: "Add SpeedRun maze mode with 10 levels, local best times, and leaderbo…",
        description: "Add SpeedRun maze mode with 10 levels, local best times, and leaderboard API.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-mobile-wasd-slide-off-and-wider-cursor-margin",
        date: "2026-04-30",
        title: "Mobile WASD slide-off and wider cursor margin",
        description: "On mobile you can slide your finger off WASD to keep moving, with a wider cursor border.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-d-pad-only-in-wasd-mode-roulette-wasd-y-sandbox-",
        date: "2026-04-30",
        title: "D-Pad only in WASD mode, roulette WASD y sandbox WASD",
        description: "D-Pad only in WASD mode, roulette WASD y sandbox WASD.",
        category: "gameplay"
    },
    {
        id: "2026-04-30-e-key-toggles-sidebar",
        date: "2026-04-30",
        title: "E key toggles sidebar",
        description: "Press E to open and close the sidebar; labels show the [E] shortcut.",
        category: "settings"
    },
    {
        id: "2026-04-30-pause-y-return-more-transparent-near-the-cursor-",
        date: "2026-04-30",
        title: "Pause y Return more transparent near the cursor en escritorio",
        description: "Pause y Return more transparent near the cursor en escritorio.",
        category: "visual"
    },
    {
        id: "2026-04-30-d-pad-position-in-settings-preview-wasd-arrastre",
        date: "2026-04-30",
        title: "D-Pad position in Settings (preview WASD + arrastre); slightly narrow…",
        description: "D-Pad position in Settings (preview WASD + arrastre); slightly narrower sidebar.",
        category: "settings"
    },
    {
        id: "2026-04-30-mobile-d-pad-and-device-ranking",
        date: "2026-04-30",
        title: "Mobile D-Pad and Device ranking",
        description: "Mobile D-Pad uses button colors, rankings show Device, and unused cursor/hitbox settings were removed.",
        category: "settings"
    },
    {
        id: "2026-04-30-pause-shows-cursor-and-wider-sidebar",
        date: "2026-04-30",
        title: "Pause shows cursor and wider sidebar",
        description: "Pause keeps the cursor visible while the game is frozen. Sign in appears on Home and in the sidebar.",
        category: "bug-fix"
    },
    {
        id: "2026-04-30-pointer-lock-during-gameplay-system-cursor-hidde",
        date: "2026-04-30",
        title: "Pointer lock during gameplay (system cursor hidden; movement with mov…",
        description: "Pointer lock during gameplay (system cursor hidden; movement with movementX/Y).",
        category: "gameplay"
    },
    {
        id: "2026-04-30-sidebar-and-messages-polish",
        date: "2026-04-30",
        title: "Sidebar and messages polish",
        description: "Narrower sidebar, messages no longer flicker on refresh, animated pause countdown, and relative mouse from center.",
        category: "bug-fix"
    },
    {
        id: "2026-04-30-footer-credits-a-adrilou111",
        date: "2026-04-30",
        title: "Footer credits a AdriLou111",
        description: "Footer credits a AdriLou111.",
        category: "visual"
    },
    {
        id: "2026-04-30-fixed-site-footer",
        date: "2026-04-30",
        title: "Fixed site footer",
        description: "A fixed footer shows the year, credits, and copyright.",
        category: "bug-fix"
    },
    {
        id: "2026-04-25-hidden-gana-a-selectores-por-id-overlay-y-clics",
        date: "2026-04-25",
        title: ".hidden gana a selectores por id (overlay y clics)",
        description: ".hidden gana a selectores por id (overlay y clics).",
        category: "visual"
    },
    {
        id: "2026-04-25-fix-resume-counter-messages-messages-pause-mobil",
        date: "2026-04-25",
        title: "Fix resume counter, messages→Messages, pause mobile, touch overlay, u…",
        description: "Fix resume counter, messages→Messages, pause mobile, touch overlay, username.",
        category: "bug-fix"
    },
    {
        id: "2026-04-25-ui-improvements-return-button-sidebar-pause-coun",
        date: "2026-04-25",
        title: "UI improvements - RETURN button, sidebar, pause countdown, messages, …",
        description: "UI improvements - RETURN button, sidebar, pause countdown, messages, username uniqueness.",
        category: "gameplay"
    },
    {
        id: "2026-04-24-refine-play-controls-layout-and-sidebar-sizing",
        date: "2026-04-24",
        title: "Refine play controls layout and sidebar sizing",
        description: "Refine play controls layout and sidebar sizing.",
        category: "visual"
    },
    {
        id: "2026-04-24-add-retro-sidebar-navigation-and-auth-first-entr",
        date: "2026-04-24",
        title: "Add retro sidebar navigation and auth-first entry flow",
        description: "Add retro sidebar navigation and auth-first entry flow.",
        category: "visual"
    },
    {
        id: "2026-04-24-social-profile-and-cloud-sandbox",
        date: "2026-04-24",
        title: "Social profile and cloud sandbox",
        description: "Public profiles, cloud sandbox presets, best-score rankings, and touch controls without a joystick.",
        category: "gameplay"
    },
    {
        id: "2026-04-24-mobile-first-menus-virtual-joystick-and-touch-po",
        date: "2026-04-24",
        title: "Mobile-first menus + virtual joystick and touch pointer",
        description: "Mobile-first menus + virtual joystick and touch pointer.",
        category: "gameplay"
    },
    {
        id: "2026-04-24-email-password-auth-session-cookies-rankings-ui-",
        date: "2026-04-24",
        title: "Email/password auth, session cookies, rankings UI, auto-submit scores",
        description: "Email/password auth, session cookies, rankings UI, auto-submit scores.",
        category: "gameplay"
    },
    {
        id: "2026-04-24-phase-1-pause-accessibility-credits-adrilou111-e",
        date: "2026-04-24",
        title: "Phase 1 pause, accessibility, credits (AdriLou111), English UI strings",
        description: "Phase 1 pause, accessibility, credits (AdriLou111), English UI strings.",
        category: "settings"
    }
];
